exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-modules-icons-components-SquareIcon-___styles__square-icon___2Y8DY {\n  padding: 4px; }\n", ""]);

// Exports
exports.locals = {
	"square-icon": "src-modules-icons-components-SquareIcon-___styles__square-icon___2Y8DY"
};